import {BettingAdFactory} from "./betting-ad.factory";
import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";
import {BaseUtilsService} from "../../../infrastructure/domain-services/base-utils-service";

export class BettingAdApi extends BaseApiService {
  static injectables = [...BaseUtilsService.injectables, BettingAdFactory];
}


